import React from 'react';
import { UserStats } from '../../types';

interface UserStatsCardProps {
  stats: UserStats;
}

/**
 * ユーザー統計カード
 * 管理者ダッシュボード用の統計情報表示
 */
const UserStatsCard: React.FC<UserStatsCardProps> = ({ stats }) => {
  const statsData = [
    {
      title: '総ユーザー数',
      value: stats.total_users,
      icon: 'fas fa-users',
      color: 'primary',
      description: '登録されているユーザーの総数'
    },
    {
      title: 'アクティブユーザー',
      value: stats.active_users,
      icon: 'fas fa-user-check',
      color: 'success',
      description: '有効なユーザー数'
    },
    {
      title: 'スタッフ',
      value: stats.staff_users || 0,
      icon: 'fas fa-user-shield',
      color: 'warning',
      description: 'スタッフ権限を持つユーザー数'
    },
    {
      title: '最近の登録',
      value: stats.recent_registrations || 0,
      icon: 'fas fa-user-plus',
      color: 'info',
      description: '過去7日間の新規登録数'
    },
    {
      title: '最近のログイン',
      value: stats.recent_logins || 0,
      icon: 'fas fa-sign-in-alt',
      color: 'secondary',
      description: '過去7日間のログイン数'
    }
  ];

  return (
    <div className="card">
      <div className="card-header">
        <h5 className="mb-0">
          <i className="fas fa-chart-line me-2"></i>
          ユーザー統計
        </h5>
      </div>
      <div className="card-body">
        <div className="row">
          {statsData.map((stat, index) => (
            <div key={index} className="col-lg col-md-6 mb-3">
              <div className={`card border-${stat.color} h-100`}>
                <div className="card-body text-center">
                  <div className={`text-${stat.color} mb-2`}>
                    <i className={`${stat.icon} fa-2x`}></i>
                  </div>
                  <h3 className={`mb-1 text-${stat.color}`}>
                    {stat.value.toLocaleString()}
                  </h3>
                  <h6 className="card-title mb-1">{stat.title}</h6>
                  <small className="text-muted">{stat.description}</small>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserStatsCard; 